import { DataTypeProvider } from "@devexpress/dx-react-grid"
import { Box, Chip } from "@mui/material"
import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import TimeAgo from 'react-timeago'
import { styled } from '@mui/material/styles';
//import Button from '@mui/material/Button';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import axios from "axios"
//import Typography from '@mui/material/Typography';

// ************************************************************

// const BootstrapTooltip = styled(({ className, ...props }) => (
//   <Tooltip {...props} arrow classes={{ popper: className }} />
// ))(({ theme }) => ({
//   [`& .${tooltipClasses.arrow}`]: {
//     color: theme.palette.common.black,
//   },
//   [`& .${tooltipClasses.tooltip}`]: {
//     backgroundColor: theme.palette.common.black,
//   },
// }));

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));

const KeygenFormatter = ({ value }) => {
  if (value === 0)
    return <>{value}</>
  var a = [ 
    "Plus Max Standard",
    "Plus Max ISO",
    "Plus Max RE",
    "Plus Max UZ",
    "Omegas",
  ]
  var i = 0
  var t = a.map(aa => {
    var bit = i++
    if ((value & (1 << bit)) !== 0) {
      return (
        <div key={bit}>
          <em>{"bit " + bit + ": "}</em>
          <b>{aa}</b>
          <br />
        </div>
      )
    } else {
      return null
    }
  })
  return (
    <>
    <b style={{ color: 'red' }}>    
      {value}
    </b>
    <br />
    {/* <Chip size="small" label={(value >>> 0).toString(2) + "b"} /> */}
    {/* <em>{(value >>> 0).toString(2) + "b"}</em> */}
    <HtmlTooltip
        title={
          <div>
            {/* <Typography color="inherit">UNLOCKER</Typography> */}
            {/* <em>{"And here's"}</em> <b>{'some'}</b> <u>{'amazing content'}</u>.{' '} */}
            {/* {"It's very engaging. Right?"} */}
            {t}
          </div>
        }
      >
      <Box sx={{ fontFamily: 'Monospace', fontSize: 10, m: 0, p: 0 }}>
        {(value >>> 0).toString(2) + "b"}
      </Box>
    </HtmlTooltip>
    </>
  )
}
export const KeygenTypeProvider = props => <DataTypeProvider formatterComponent={KeygenFormatter} {...props} />

function intToIP(int) {
  var part1 = int & 255;
  var part2 = ((int >> 8) & 255);
  var part3 = ((int >> 16) & 255);
  var part4 = ((int >> 24) & 255);
  return part4 + "." + part3 + "." + part2 + "." + part1;
}

const decodeBase64ToUtf8 = (base64String) => {
  try {
    return decodeURIComponent(
      escape(window.atob(base64String))
    );
  } catch (e) {
    console.error("Errore durante la decodifica Base64: ", e);
    return '';
  }
};

const GeoFormatter = ({ row, geoField, ipAddrField }) => {
  const [flagUrl, setFlagUrl] = useState('')
  const [countryName, setCountryName] = useState('')
  const [countryCode, setCountryCode] = useState('')

  // Cache object to store fetched data
  const cache = GeoFormatter.cache || (GeoFormatter.cache = {})

  const geoData = row[geoField] ? row[geoField].trim() : ''
  const ipData = row[ipAddrField] ? row[ipAddrField] : 0

  useEffect(() => {
    if (geoData) {
      const geo = JSON.parse(decodeBase64ToUtf8(geoData));
      const countryCode = geo.countryCode;
      setCountryName(geo.country)
      setCountryCode(countryCode)

      // Check if the data is in the cache
      if (cache[countryCode]) {
        setFlagUrl(cache[countryCode].flagUrl)
      } else {
        axios.get(`https://restcountries.com/v3.1/alpha/${countryCode}?fields=flags`).then(response => {
          try {
            const flagPngUrl = response.data.flags.png;
            setFlagUrl(flagPngUrl)
            // Store the fetched data in the cache
            cache[countryCode] = { flagUrl: flagPngUrl }
          } catch (error) {
            // Handle error
          }
        }).catch(error => {
          // Handle error
        })
      }
    }
  }, [geoData]);

  if (!geoData) {
    if (ipData === 0) 
      return <></>
    console.log("ipData: ", ipData)
    return <Chip label={intToIP(ipData)} size="small" color="default" />    
  }
  return (
    <>
      {flagUrl ? (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img src={flagUrl} alt="Country flag" width="32" height="20" />
          {countryName && <span style={{ marginLeft: '8px' }}>{countryName}</span>}
        </div>
      ) : (
        <>{countryName && <span>{countryName}</span>}</>
      )}
    </>
  )
}

const GeoSimpleFormatter = ({ row, geoField }) => {
  const [flagUrl, setFlagUrl] = useState('')
  const [countryName, setCountryName] = useState('')
  const [countryCode, setCountryCode] = useState('')

  // Cache object to store fetched data
  const cache = GeoSimpleFormatter.cache || (GeoSimpleFormatter.cache = {})
  const geoData = row[geoField] ? row[geoField].trim() : ''
  
  useEffect(() => {
    if (geoData) {
      const geo = JSON.parse(decodeBase64ToUtf8(geoData));
      const countryCode = geo.countryCode;
      setCountryName(geo.country)
      setCountryCode(countryCode)

      // Check if the data is in the cache
      if (cache[countryCode]) {
        setFlagUrl(cache[countryCode].flagUrl)
      } else {
        axios.get(`https://restcountries.com/v3.1/alpha/${countryCode}?fields=flags`).then(response => {
          try {
            const flagPngUrl = response.data.flags.png;
            setFlagUrl(flagPngUrl)
            // Store the fetched data in the cache
            cache[countryCode] = { flagUrl: flagPngUrl }
          } catch (error) {
            // Handle error
          }
        }).catch(error => {
          // Handle error
        })
      }
    }
  }, [geoData]);

  if (!geoData) {
    return <></>    
  }
  return (
    <>
      {flagUrl ? (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img src={flagUrl} alt="Country flag" width="32" height="20" />
          {countryName && <span style={{ marginLeft: '8px' }}>{countryName}</span>}
        </div>
      ) : (
        <>{countryName && <span>{countryName}</span>}</>
      )}
    </>
  )
}

export const GeoTypeProvider = ({ ipAddrField, geoField, ...props }) => (
  <DataTypeProvider formatterComponent={(rowProps) => <GeoFormatter {...rowProps} ipAddrField={ipAddrField} geoField={geoField} />} {...props} />
)
export const GeoSimpleTypeProvider = ({ geoField, ...props }) => (
  <DataTypeProvider formatterComponent={(rowProps) => <GeoSimpleFormatter {...rowProps} geoField={geoField} />} {...props} />
)

const DateFormatter = ({ value }) => {
  if (!value) 
    return <></>
  if (value === "0000-00-00 00:00:00")
    return <></>
  return (
    <b style={{ color: 'darkblue' }}>    
      <TimeAgo date={value} />
    </b>
  )
}
export const DateTypeProvider = props => <DataTypeProvider formatterComponent={DateFormatter} {...props} />

const RowNumFormatter = ({ row }) => {
  if (row.is_admin && row.is_reseller) return <Chip label={row.row_num} size="small" color="error" />
  if (row.is_admin) return <Chip label={row.row_num} size="small" color="warning" />
  if (row.is_reseller) return <Chip label={row.row_num} size="small" color="info" />
  return <Chip label={row.row_num} size="small" variant="outlined" />  
}
export const RowNumTypeProvider = props => <DataTypeProvider formatterComponent={RowNumFormatter} {...props} />

const IsAdminFormatter = ({ value }) => {
  if (value) return <Chip label="1" color="warning" />
  return <Chip label="0" variant="outlined" />  
}
export const IsAdminTypeProvider = props => <DataTypeProvider formatterComponent={IsAdminFormatter} {...props} />

const IsResellerFormatter = ({ value }) => {
  if (value) return <Chip label="1" color="info" />
  return <Chip label="0" variant="outlined" />  
}
export const IsResellerTypeProvider = props => <DataTypeProvider formatterComponent={IsResellerFormatter} {...props} />

const AccessoWebFormatter = ({ value }) => {
  if (!value) return <Chip label="0" color="warning" />
  return <Chip label="1" variant="outlined" color="success" />  
}
export const AccessoWebTypeProvider = props => <DataTypeProvider formatterComponent={AccessoWebFormatter} {...props} />

const PasswordHashFormatter = ({ value }) => {
  if (!value) return <Chip label="0" color="warning"  />
  return <Chip label="1" color="success" variant="outlined" />  
}
export const PasswordHashTypeProvider = props => <DataTypeProvider formatterComponent={PasswordHashFormatter} {...props} />

const UsernameFormatter = ({ row }) => {
  return <Link to={"/service/user/details/" + row.id}>{row.username}</Link>
}
export const UsernameTypeProvider = props => <DataTypeProvider formatterComponent={UsernameFormatter} {...props} />

// const ResellerUsernameFormatter = ({ row }) => {
//   return <Link to={"/service/user/details/" + row.reseller_id}>{row.reseller_username}</Link>
// }
// export const ResellerUsernameTypeProvider = props => <DataTypeProvider formatterComponent={ResellerUsernameFormatter} {...props} />

const SwNameFormatter = ({ value }) => {
  value = (!value) ? '' : value.trim()
  if (value == '') 
    return <></>
  return (
    <Box sx={{ fontWeight: 'bold', fontFamily: 'Monospace', fontSize: 12, p: 1, m: 0.5, color: 'text.primary' }}>
      {value}
    </Box>
  )
}
export const SwNameTypeProvider = props => <DataTypeProvider formatterComponent={SwNameFormatter} {...props} />

const UserCodeFormatter = ({ value }) => {
  return (
    <Box sx={{ fontFamily: 'Monospace', fontSize: 10, m: 1 }}>
      {value}
    </Box>
  )
}
export const UserCodeTypeProvider = props => <DataTypeProvider formatterComponent={UserCodeFormatter} {...props} />

const UserTypeFormatter = ({ row }) => {
  return (
    <div style={{ display: 'flex', gap: '4px' }}>
      <Tooltip title="Admin">
        {row.is_admin ? (
          <Chip label="A" color="error" />
        ) : (
          <Chip label="A" variant="outlined" disabled />
        )}
      </Tooltip>
      <Tooltip title="Reseller">
        {row.is_reseller ? (
          <Chip label="R" color="warning" />
        ) : (
          <Chip label="R" variant="outlined" disabled />
        )}
      </Tooltip>
      <Tooltip title="Gas Specialist">
        {row.is_gas_specialist ? (
          <Chip label="G" color="success" />
        ) : (
          <Chip label="G" variant="outlined" disabled />
        )}
      </Tooltip>
    </div>
  )
}
export const UserTypeTypeProvider = props => <DataTypeProvider formatterComponent={UserTypeFormatter} {...props} />

// ************************************************************

export default class ServiceUserListTableProps {
  getTableColumns(user) {
    if (1) {
      return [
        { name: 'row_num',                title: '#',                   getCellValue: row => row.row_num },
        //{ name: 'id',                     title: 'Id',                  getCellValue: row => row.id },
        { name: 'first_name',             title: 'First Name',          getCellValue: row => row.first_name },
        { name: 'last_name',              title: 'Last Name',           getCellValue: row => row.last_name },
        { name: 'company_name',           title: 'Company Name',        getCellValue: row => row.company_name },
        //{ name: 'company_city',           title: 'Company City',        getCellValue: row => row.company_city },
        //{ name: 'company_state',          title: 'Company State',       getCellValue: row => row.company_state },
        { name: 'company_country',        title: 'Company Country',     getCellValue: row => row.company_country },
        //{ name: 'phone',                  title: 'Phone',               getCellValue: row => row.phone },
        { name: 'email',                  title: 'Email',               getCellValue: row => row.email },
        { name: 'username',               title: 'Username',            getCellValue: row => row.username },
        { name: 'LR_user_code',        title: 'LR User Code',     getCellValue: row => row.LR_user_code },
        { name: 'created_at',             title: 'Created at',          getCellValue: row => row.created_at },
        //{ name: 'activated_at',           title: 'Activated at',        getCellValue: row => row.activated_at },
        { name: 'accesso_keygen',         title: 'KEYGEN',              getCellValue: row => row.accesso_keygen },
        //{ name: 'accesso_web',            title: 'ACTIVATED',           getCellValue: row => row.accesso_web },

        { name: 'u_user_type',            title: 'User type',           getCellValue: row => row.u_user_type },
        // { name: 'is_admin',               title: 'A',                   getCellValue: row => row.is_admin },
        // { name: 'is_reseller',            title: 'R',                   getCellValue: row => row.is_reseller },      
        // { name: 'is_gas_specialist',      title: 'G',                   getCellValue: row => row.is_gas_specialist },      
        
        // { name: 'reseller_username',      title: 'Reseller',            getCellValue: row => row.reseller_username },
        //{ name: 'is_password_hashed',     title: 'Hashed',              getCellValue: row => row.is_password_hashed },
        { name: 'last_activity_date',     title: 'Activity',            getCellValue: row => row.last_activity_date },
        { name: 'last_activity_ip_data',  title: 'Geo',                 getCellValue: row => row.last_activity_ip_data },
        { name: 'last_activity_program_name',  title: 'Program name',   getCellValue: row => row.last_activity_program_name },
        { name: 'last_activity_user_code',  title: 'User code',   getCellValue: row => row.last_activity_user_code },
      ]
    }
    
    var a = [
      { name: 'row_num',                title: '#',                   getCellValue: row => row.row_num },
      { name: 'id',                     title: 'Id',                  getCellValue: row => row.id },
      { name: 'first_name',             title: 'First Name',          getCellValue: row => row.first_name },
      { name: 'last_name',              title: 'Last Name',           getCellValue: row => row.last_name },
      { name: 'company_name',           title: 'Company Name',        getCellValue: row => row.company_name },
      //{ name: 'company_city',           title: 'Company City',        getCellValue: row => row.company_city },
      //{ name: 'company_state',          title: 'Company State',       getCellValue: row => row.company_state },
      { name: 'company_country',        title: 'Company Country',     getCellValue: row => row.company_country },
      { name: 'phone',                  title: 'Phone',               getCellValue: row => row.phone },
      { name: 'email',                  title: 'Email',               getCellValue: row => row.email },
      { name: 'username',               title: 'Username',            getCellValue: row => row.username },
      { name: 'LR_user_code',           title: 'LR User Code',       getCellValue: row => row.LR_user_code },
      { name: 'created_at',             title: 'Created at',          getCellValue: row => row.created_at },
      { name: 'activated_at',           title: 'Activated at',        getCellValue: row => row.activated_at },
      { name: 'accesso_keygen',         title: 'KEYGEN',              getCellValue: row => row.accesso_keygen },
      { name: 'accesso_web',            title: 'ACTIVATED',           getCellValue: row => row.accesso_web },
      
      { name: "u_user_type",            title: "User type",           getCellValue: row => row.u_user_type },
      // { name: 'is_admin',               title: 'A',               getCellValue: row => row.is_admin },
      // { name: 'is_reseller',            title: 'R',               getCellValue: row => row.is_reseller },      
      // { name: 'is_gas_specialist',      title: 'G',               getCellValue: row => row.is_gas_specialist },      
    ]
    if (user === null)
      return a 
    if (user.is_admin) {
      a.push.apply(a, [
        // { name: 'reseller_username',      title: 'Reseller',            getCellValue: row => row.reseller_username },
        { name: 'is_password_hashed',     title: 'Hashed',              getCellValue: row => row.is_password_hashed },
        { name: 'last_activity_date',     title: 'Activity',            getCellValue: row => row.last_activity_date },
        { name: 'last_activity_ip_data',  title: 'Geo',                 getCellValue: row => row.last_activity_ip_data },
      ])
    }
    return a
  }  
  getTableColumnWidths(user) {
    if (user === null) {
      // TODO: da implementare ....... ALLA FINE NON SERVE IN QUESTO CASO POICHE' LA LISTA DEGLI UTENTI E' SOLO PER ADMIN
    }
    return [
      { columnName: 'row_num',                width: 100 },
      { columnName: 'id',                     width:   0 },
      { columnName: 'first_name',             width: 100 },
      { columnName: 'last_name',              width: 100 },
      { columnName: 'company_name',           width: 140 },
      //{ columnName: 'company_city',           width: 140 },
      //{ columnName: 'company_state',          width: 140 },
      { columnName: 'company_country',        width: 140 },
      { columnName: 'phone',                  width: 120 },
      { columnName: 'email',                  width: 160 },
      { columnName: 'username',               width: 140 },
      { columnName: 'LR_user_code',           width: 120 },
      { columnName: 'created_at',             width: 120 },
      { columnName: 'activated_at',           width: 120 },
      { columnName: 'accesso_keygen',         width:  80 },
      { columnName: 'accesso_web',            width:  80 },
      
      { columnName: 'u_user_type', width: 120 },
      // { columnName: 'is_admin',               width: 70 },
      // { columnName: 'is_reseller',            width: 70 },
      // { columnName: 'is_gas_specialist',      width: 70 },

      // { columnName: 'reseller_username',      width: 140 },
      { columnName: 'is_password_hashed',     width: 80 },
      { columnName: 'last_activity_date',     width: 120 },
      { columnName: 'last_activity_ip_data',  width: 120 },
      { columnName: 'last_activity_program_name',  width: 145 },
      { columnName: 'last_activity_user_code',  width: 395 },
    ]
  }
  getTableColumnExtensions() {
    return [
      { columnName: 'row_num',                align: 'right' },
      { columnName: 'id',                     align: 'right' },
      { columnName: 'accesso_keygen',         align: 'right' },
      { columnName: 'created_at',             align: 'right' },
      { columnName: 'activated_at',           align: 'right' },
      { columnName: 'accesso_web',            align: 'right' },
      { columnName: 'LR_user_code',            align: 'right' },
      // { columnName: 'is_admin',               align: 'right' },
      // { columnName: 'is_reseller',            align: 'right' },
      // { columnName: 'is_gas_specialist',      align: 'right' },
      { columnName: 'is_password_hashed',     align: 'right' },
      { columnName: 'last_activity_date',     align: 'right' },
    ]
  }
  getTableSortingStateColumnExtensions() {
    return [
      { columnName: 'row_num',                    sortingEnabled: false },
      { columnName: 'phone',                      sortingEnabled: false },
      { columnName: 'is_password_hashed',         sortingEnabled: false },
      { columnName: 'last_activity_ip_data',      sortingEnabled: false },
      { columnName: 'last_activity_program_name', sortingEnabled: false },
      { columnName: 'last_activity_user_code',    sortingEnabled: false },
      { columnName: 'u_user_type',                sortingEnabled: false },
    ]
  }
  getTableFilteringStateColumnExtensions() {
    return [
      { columnName: 'row_num',                    filteringEnabled: false },
      { columnName: 'id',                         filteringEnabled: false },
      { columnName: 'created_at',                 filteringEnabled: false },
      { columnName: 'activated_at',               filteringEnabled: false },
      { columnName: 'is_password_hashed',         filteringEnabled: false },
      { columnName: 'last_activity_date',         filteringEnabled: false },
      { columnName: 'last_activity_ip_data',      filteringEnabled: false },
      { columnName: 'last_activity_program_name', filteringEnabled: false },
      { columnName: 'last_activity_user_code',    filteringEnabled: false },
    ]
  }
}
